export default {
  default: () => import("/builds/helmundwalter/homepage/helmundwalter.de/layouts/default.vue"),
  "toc-sidebar": () => import("/builds/helmundwalter/homepage/helmundwalter.de/layouts/tocSidebar.vue")
}